import React, { useState, useEffect } from 'react';
import "../components/styles/profile.css"
import { logo } from '../assets/svg/svg.js';
import Cookies from "universal-cookie";
import { getUserContract } from '../helper/contract-helper.js';
import { getContacts, web3AccountCheck } from '../helper/web3helper.js';
import { forceRefreshWalletCache } from '../helper/wallet-helper.js';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { deleteContacts, deleteDatabase } from '../db/db-helper.js';
import { clearContactsDekCache } from '../helper/contactsDek.js';
import { clearDekCache } from '../helper/dekManager.js';
import { clearEnvelopeKeyCache } from '../helper/envelopeV3.js';
import Loader from './Loader.js';
import { getFirstLetterUppercase } from '../helper/object-validation-helper.js';
import { createWeb2User, login } from "../service/api-actions"
// import { log } from "../service/api-actions.js";
import { getBrowserDetails } from '../helper/userActivity.js';
import { buildLoginProof } from "../auth/loginProof.js";
import { Bounce, toast } from 'react-toastify';
import { reportError, toErrorString } from '../utils/errorLogger.js';
import { logout } from '../authMiddleware.js';
import web3Config from "../web3/web3Config.json";

const cookies = new Cookies();

const Profile = (props) => {

  const history = useNavigate(); // Get the history object

  const [user] = useState(cookies.get("userObject"));
  const [emailAddresses, setEmailAddresses] = useState([]);
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [loader, setLoader] = useState(true);


  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);


  useEffect(() => {
    async function getUserDetailsForWallet() {
      setLoader(true);
      try {
        const contract = getUserContract();
        if (account) {
          const getUserDetailsForWallet = await contract.methods.getUserDetailsForWallet(account).call();
          let loginUserIndex = getUserDetailsForWallet.findIndex(Item => Item.userName == user.name)
          let loginUser = _.pullAt(getUserDetailsForWallet, loginUserIndex)
          setEmailAddresses(_.concat(loginUser, getUserDetailsForWallet));
        }
      } catch (err) {
        console.log(err);
      }
      setLoader(false);
    }

    getUserDetailsForWallet();

  }, [account]);


  function handleEmailChange(event, index) {
    switchAccount(emailAddresses[index]);
  }

  async function clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
    cookies.remove("userObject");
    cookies.remove("accessToken");
    await deleteContacts();
    // A real teardown: drop the cached mail AND the in-memory DEKs together, so the next account can
    // neither read the previous account's rows nor inherit its keys.
    clearDekCache();
    clearContactsDekCache();
    // And the v3 per-message content keys, so the next account cannot open this one's mail from memory.
    clearEnvelopeKeyCache();
    await deleteDatabase();
  }

  async function switchAccount(user) {
    if (!user.publicKey) {
      await clearStorage();
      window.open('/', '_self');
      return true;
    }
    setLoader(true);
    const userObject = { name: user.userName, wallet: user.walletAddress, publicKey: user.publicKey };
    // Account switch: prove possession of the wallet for the account being switched TO, then log in as
    // that account. A failed proof is reshaped into login()'s failure shape so the existing
    // clear-storage-and-toast branch below handles it — switchAccount has no caller-side catch, so an
    // uncaught throw here would leave the loader spinning with no explanation on screen.
    let getToken;
    try {
      const { signature, signerPublicKey } = await buildLoginProof(user.userName, user.publicKey);
      getToken = await login(user.userName, user.publicKey, null, signature, signerPublicKey);
    } catch (proofError) {
      getToken = { isAuth: false, isAccess: false, message: proofError.message };
    }
    if (getToken && getToken.isAuth && getToken.token) {
      try {
        let checkCancelEvent = await getContacts(user.userName);
        if (!checkCancelEvent && checkCancelEvent != undefined) {
          setLoader(false)
          return null
        }

        await clearStorage();
        cookies.set("userObject", userObject, { path: "/" });
        cookies.set("accessToken", getToken.token, { path: "/" });
        localStorage.setItem("accessToken", getToken.token);
        localStorage.setItem("userObject", JSON.stringify(userObject));
        localStorage.setItem("UserName", userObject.name);
        const accounts = await window.ncogProvider.request({ method: "ncog_accounts" });
        if (accounts?.selectedAccount?.accountAddress) {
          setAccount(accounts?.selectedAccount?.accountAddress);
          localStorage.setItem("walletAddress", accounts?.selectedAccount?.accountAddress);
        }

        await createWeb2User(user.userName);
      } catch (error) {
        const userName = localStorage.getItem('UserName');
        const errorStr = toErrorString(error || error.message);
        reportError({
          endpoint: '/getContactDetails, /createWeb2User, https://api.ipify.org?format=jso',
          message: `FileName: profile.js, Fun: switchAccount, ${String(error.message || 'Unhandled error')}`,
          error: errorStr,
          userName: userName || '',
        });
        console.error("Error while getting contacts:", error);
      }
      window.open('/app/inbox', '_self');
    } else if (!getToken?.isAccess && !getToken.isAuth) {
      await clearStorage();
      toast.error(getToken?.message, {
        position: "top-center",
        transition: Bounce,
        autoClose: 5000,
      });
      window.open('/app', '_self');
    } else {
      await clearStorage();
      window.open('/app/signup', '_self');
    }
  }

  const handleManageAccount = () => {
    const token = localStorage.getItem("accessToken"); 
    const baseUrl = web3Config.MY_ACCOUNT_BASE_URL;
    const finalUrl = `${baseUrl}?token=${token}`;
    window.open(finalUrl, "_blank");
  }

  return props?.isProfileOpen && (
    <>
      {loader && <div className='profile-container'> <Loader /> </div>}
      {!loader &&
        <div className='profile-container z-1001'>
          <div className='close-icon-profile'>
            <div className='cursor-pointer' onClick={props.handleProfile} >  {logo.close_svg} </div>
          </div>
          <div className='header-data-profile'>
            <div className='flex items-center gap-20'>
              {/* <div> {logo.svg_notification} </div> */}
              <div className="profile-pic-profile-component">{getFirstLetterUppercase(user.name.split("@")[0])}</div>
              <div className='profile-name-username-section'>
                <span className='profile-welcome' > Welcome </span>
                <span className='profile-welcome-name'>{user && user.name.split("@")[0]}</span>
                <span className='profile-welcome profile-welcome-email'>{user && user.name}</span>
              </div>
            </div>
            <div className='dot-menu-profile'>
              {/* <div> {logo.svg_menu_dot_pofile} </div> */}
            </div>
          </div>

          <div className='profile-address-switch-container'>
            <span className='text-span-switch-email-heading'> Switch Email Address </span>
            {emailAddresses.length > 0 && <>
              {emailAddresses.map((email, index) => {
                if (!email) return ""
                return (
                  <div className='row-content-user-address-profile flex' key={index}
                    onClick={() => { if (user?.name !== email.userName) handleEmailChange(null, index); }}>
                    <div className='user-name-section switch-account col-10'>
                      <div className='address-profile-img '>
                        <div className='user-profile-pic'>{getFirstLetterUppercase(email.userName.split('@')[0])} </div>
                      </div>
                      <span className='address swich-account-address'>
                        <span className='swich-account-name-line'>{(email.userName.split('@')[0])}</span>
                        <span className='profile-welcome w-full'>{email.userName}</span>
                      </span>
                    </div>

                    <div className='checkbox-user-profile col-2'>
                      <label className='label-profile-radio inline'>
                        <span className={user?.name === email.userName ? 'active' : ''}></span>
                        <input
                          type="radio"
                          className="profile-input-radio on cursor-pointer"
                          name="email-address"
                          value={email.userName}
                          checked={user?.name === email.userName}
                          onChange={(e) => {
                            handleEmailChange(e, index)
                          }
                          }
                        />
                      </label>
                    </div>
                  </div>
                )
              })}
            </>
            }
          </div>

          <div className='profile-address-switch-container merge-start'>
            <div className='row-content-user-address-profile btn-profile-add'>
              <div className='show-btn profile-select add-account-btn cursor-pointer' onClick={() => {
                history('signup')
              }} > {logo.add_plus_svg} Add New Account </div>
            </div>
          </div>
          {/* MANAGE ACCOUNT BUTTON */}
          <div className="profile-address-switch-container manage-account-btn-container">
            <div
              className="show-btn profile-select manage-account-btn cursor-pointer"
              onClick={handleManageAccount}
            >
              {logo.settings_svg} Manage Account
            </div>
          </div>
          {/*
            ONE LOGOUT, NOT TWO. This button used to inline its own copy of the wipe, and the copy drifted:
            it expired only the `userObject` cookie, so the path-"/" `accessToken` survived and "Log Out"
            left a usable bearer token behind — and its unguarded awaits could be blocked indefinitely by
            an IndexedDB delete another tab was holding open, in which case the button did nothing at all.
            authMiddleware.logout() clears the credentials and the in-memory keys FIRST and synchronously,
            then wipes the caches best-effort under a timeout, so neither failure mode survives. Keeping a
            second copy here is what let them diverge in the first place.
          */}
          <div className='logout-btn-profile-container cursor-pointer' onClick={logout}>
            {logo.log_out_profile}  <span className='span-text-logout-btn'> Log Out </span>

          </div>
        </div>
      }
    </>
  )
}

export default Profile
